export function OutlinePuntoIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9998 16C14.2089 16 15.9998 14.2091 15.9998 12C15.9998 9.79086 14.2089 8 11.9998 8C9.79062 8 7.99976 9.79086 7.99976 12C7.99976 14.2091 9.79062 16 11.9998 16Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
